<script setup lang="ts">
import useSwr from "@/core/composables/swr/useSwr";
import {featureHighlightApi} from "@/container";
import {computed, ref} from "vue";
import {cacheKey} from "@/lib/cache";
import {CalendarDays, Clock, Play} from "@lucide/vue";
import EmbedVideoModalButton from "@/video/components/EmbedVideoModalButton.vue";
import dateHelper from "@/core/helpers/dateHelper";
import BaseFlexSpinner from "@/core/components/base/spinner/BaseFlexSpinner.vue";

const page = ref(1);

const {data: featureHighlightResponse, isLoading} = useSwr(
    computed(() => cacheKey(`feature-highlights?page=${page.value}`)),
    () => featureHighlightApi().index(false, {page: page.value}),
);

</script>

<template>
  <BaseFlexSpinner v-if="isLoading" />
  <div v-if="featureHighlightResponse?.data?.length" class="flex flex-col gap-4 p-6">
    <div v-for="feature in featureHighlightResponse.data" :key="feature.id" class="flex flex-col bg-white rounded-lg p-4 gap-2">
      <div class="flex flex-col gap-2 py-2">
        <h2 class="text-xl font-semibold">
          {{ feature.title }}
        </h2>
        <div class="flex flex-row items-center justify-between gap-4">
          <div class="flex flex-row items-center gap-4">
            <div class="flex flex-row items-center bg-gray-100 py-1 px-2 rounded-lg gap-2">
              <CalendarDays class="size-5 shrink-0 text-primary" />
              <span class="text-sm text-primary pt-1">{{ dateHelper.longFormat(feature.end_at) }}</span>
            </div>
            <div v-if="feature.duration" class="flex flex-row items-center bg-gray-100 py-1 px-2 rounded-lg gap-2">
              <Clock class="size-5 shrink-0 text-primary" />
              <span class="text-sm text-primary pt-1">{{ feature.duration }} min</span>
            </div>
          </div>
          <EmbedVideoModalButton v-if="feature.replay_url" :embed-video-url="feature.replay_url" :title="feature.title">
            <div class="flex items-center text-sm text-primary gap-1 bg-gray-100 hover:bg-lightPurple-lightest px-2 py-1 rounded-lg">
              <Play class="fill-red-500 text-red-500 shrink-0 w-5" />
              <p>
                Voir le replay
              </p>
            </div>
          </EmbedVideoModalButton>
          <div v-else class="flex items-center text-sm text-primary gap-1 bg-gray-100 px-2 py-1 rounded-lg">
            <p>Replay bientôt disponible</p>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center mb-4">
      <v-pagination
        v-model="page"
        :length="featureHighlightResponse?.meta?.last_page"
        :total-visible="7"
        circle
      />
    </div>
  </div>
  <div v-else class="flex flex-col items-center justify-center gap-4 p-6">
    <p>Le replay arrive bientôt !</p>
  </div>
</template>

<style scoped>

</style>
